interface LinkedInSearchInput {
  name?: string;
  email?: string;
  companyName?: string;
}

const LINKEDIN_PEOPLE_SEARCH_BASE =
  "https://www.linkedin.com/search/results/people/";

export function buildLinkedInSearchUrl({
  name,
  email,
  companyName,
}: LinkedInSearchInput): string | null {
  const keywords = [name?.trim(), companyName?.trim()]
    .filter(Boolean)
    .join(" ");

  if (keywords) {
    return `${LINKEDIN_PEOPLE_SEARCH_BASE}?keywords=${encodeURIComponent(keywords)}`;
  }

  if (email?.trim()) {
    return `${LINKEDIN_PEOPLE_SEARCH_BASE}?keywords=${encodeURIComponent(email.trim())}`;
  }

  return null;
}

export function canSearchOnLinkedIn(input: LinkedInSearchInput): boolean {
  return buildLinkedInSearchUrl(input) !== null;
}
